module.exports = __webpack_public_path__ + "id.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/id.svg
// module id = 859
// module chunks = 0